//====================================================
//  Function: Reposition Header
// - preusporiadanie prvkov v hlavičke
//====================================================
var headerHeight;
var header = $("#header");

function partsRepositionHeader() {
  repositionCartCountMobile();
  repositionLanguages();
  setActiveLanguages();
  repositionNavigationMobile();

  initHeaderFunctions();

  if ($windowWidth < bpSmall) {
    initHeaderMoreBtn();
  }

  body.addClass("is-visible-header-contact");
}

function initHeaderMoreBtn() {
  shoptet.scripts.setCustomCallback("shoptet.menu.showSubmenu", function (
    args
  ) {
    var $el = $(".menu-level-1 > .exp");
    var $thirdLevelMenu = $el.find(".has-third-level ul");
    if ($thirdLevelMenu.length) {
      $(".has-third-level ul").removeClass("has-more-items");
      $thirdLevelMenu.each(function () {
        var $lastLi = $(this).find("li:last-child");
        var lastLiOffset = getRelativeOffset($lastLi);
        var lastLiBottomLine = lastLiOffset.top + $lastLi.height();
        if (lastLiBottomLine > $(this).height()) {
          $(this)
            .addClass("has-more-items")
            .append('<span class="more-items-trigger" />');
        }
      });
    }
    if (shoptet.abilities.feature.images_in_menu) {
      $el.find("img").trigger("unveil");
    }
  });
}

function initHeaderFunctions() {
  if ($(".top-nav-button").length) {
    var loginLink = $(".top-nav-button");

    $(".navigation-buttons").prepend(loginLink);

    if ($(".click-cart").length == 0) {
      $(".toggle-window.cart-count").wrap('<div class="click-cart"></div>');
    }

    $(document).on("click", ".click-cart", function () {
      if ($windowWidth < bpMedium) {
        window.location.href = $(this).find(".cart-count").attr("href");
        return false;
      }
    });
  }

  if ($windowWidth < bpSmall) {
    $(".navigation-in ul li a.menu-image img").each(function () {
      var image = $(this);
      var imageSrc = image.attr("data-src");
      image.attr("src", imageSrc);
    });
  }
}

function repositionCartCountMobile() {
  if ($("#header .cart-count").length) {
    if ($windowWidth < bpSmall) {
      var cartCount = $("#header .cart-count").clone();
      if ($(".top-navigation-bar .click-cart").length == 0) {
        cartCount.insertBefore(
          '.responsive-tools .toggle-window[data-target="navigation"]'
        );
      } else {
        $(".top-navigation-bar .cart-count").remove();
        $(".responsive-tools .click-cart").append(cartCount);
      }
    }
  }
  if (
    $("#header .site-name").length &&
    $(".top-navigation-bar .site-name").length == 0
  ) {
    if ($(".top-navigation-bar .site-name").length == 0) {
      var headerLogo = $("#header .site-name").clone();
      $(".top-navigation-bar .container").prepend(headerLogo);
    }
  }
}

function repositionNavigationMobile() {
  $("#header .navigation-in").append(
    '<div class="navigation-in-bottom"></div>'
  );

  if ($(".top-navigation-bar .top-navigation-bar-menu").length) {
    if (
      $windowWidth < bpSmall &&
      $("#header .top-navigation-bar-menu").length == 0
    ) {
      var headerSecondaryMenu = $(
        ".top-navigation-bar .top-navigation-bar-menu"
      )
        .clone()
        .off();
      $("#header .navigation-in .navigation-in-bottom").prepend(
        headerSecondaryMenu
      );
    }
  }

  if ($(".top-navigation-bar .top-navigation-contacts").length) {
    if (
      $windowWidth < bpSmall &&
      $("#header .top-navigation-contacts").length == 0
    ) {
      var headerContacts = $(".top-navigation-bar .top-navigation-contacts")
        .clone()
        .off();
      $("#header .navigation-in .navigation-in-bottom").prepend(headerContacts);
    }
  }

  if ($(".top-navigation-bar .languagesMenu").length) {
    if ($windowWidth < bpSmall && $("#header .languagesMenu").length == 0) {
      var headerLanguage = $(".top-navigation-bar .languagesMenu")
        .clone()
        .off();
      $("#header .navigation-in .navigation-in-bottom").prepend(headerLanguage);
    }
  }

  if ($(".top-navigation-bar .top-navigation-tools .dropdown").length) {
    if ($windowWidth < bpSmall && $("#header .dropdown").length == 0) {
      var headerLanguage = $(".top-navigation-bar .dropdown").clone().off();
      $("#header .navigation-in .navigation-in-bottom").prepend(headerLanguage);
    }
  }
}

function repositionLanguages() {
  if ($(".languagesMenu__list--language").length) {
    $(".languagesMenu__list--language .js-languagesMenu__list__link").each(
      function () {
        var inst = $(this);
        var flag = inst.find(".shp-flag");
        var flagLanguageTextElement = inst.find(".languagesMenu__list__name");
        var flagLanguageHref = inst.attr("href").split("language=")[1];

        flag.wrap('<span class="flag-wrap"></span>');
        flagLanguageTextElement.text(flagLanguageHref);
      }
    );

    var actualLanguageText = $(".languagesMenu__list--language li:first-child")
      .find("a")
      .attr("href")
      .split("language=")[1];
    var actualLanguageFlag = $(".languagesMenu__list--language li:first-child")
      .find(".flag-wrap")
      .clone();
    var actualLanguage = $(
      '.js-languagesMenu__box[data-target="language"] .languagesMenu__header--actual'
    );
    actualLanguage.text(actualLanguageText);
    actualLanguage.prepend(actualLanguageFlag);
  }
}

function setActiveLanguages() {
  if ($(".js-languagesMenu__box").length) {
    $(".js-languagesMenu__box").each(function () {
      var inst = $(this);
      var actual = inst.find(".languagesMenu__header--actual");
      var actualText = actual.text().replace(/\s/g, "");
      inst
        .find(
          '.languagesMenu__list__link[href="/action/Language/changeLanguage/?language=' +
            actualText +
            '"]'
        )
        .addClass("is-active");
      inst
        .find(
          '.languagesMenu__list__link[href="/action/Currency/changeCurrency/?currencyCode=' +
            actualText +
            '"]'
        )
        .addClass("is-active");
    });
  }
}
